let body = document.querySelector('body'),
    siteHeader = document.querySelector('.wp-site-blocks > header'),
    scrollPosition,
    siteHeaderHeight,
    menuTrigger = document.querySelector('.menu-trigger'),
    mainMenuItemsHasChilds = document.querySelectorAll('.wp-site-blocks > header .header-menu .menu-item-has-children > a'),
    mainMenuSubmenus = document.querySelectorAll('.wp-site-blocks > header .header-menu .sub-menu');

function menuController() {
  if (!body.classList.contains('header-menu-active')) {
    body.classList.add('header-menu-active')
  } else {
    body.classList.remove('header-menu-active')
  }
}

function scrollHeader() {
  scrollPosition = window.scrollY;
  siteHeaderHeight = siteHeader.offsetHeight;
  if (scrollPosition > siteHeaderHeight) siteHeader.classList.add("site-header-small");
  else siteHeader.classList.remove("site-header-small");
  if (scrollPosition > 20) siteHeader.classList.add("site-header-pos-not-start");
  else siteHeader.classList.remove("site-header-pos-not-start");
}

if (menuTrigger) menuTrigger.addEventListener('click', menuController);
mainMenuItemsHasChilds.forEach(link => {
  let submenuTrigger = document.createElement('span');
  submenuTrigger.classList.add('sub-menu-trigger');
  link.after(submenuTrigger);
  submenuTrigger.addEventListener('click', (e) => {
    document.querySelectorAll('.sub-menu-trigger').forEach(trigger => {
      trigger.classList.remove('sub-menu-trigger-active');
    });
    mainMenuSubmenus.forEach(submenu => {
      submenu.classList.remove('sub-menu-active');
    });
    e.currentTarget.classList.add('sub-menu-trigger-active');
    e.currentTarget.nextElementSibling.classList.add('sub-menu-active');
  });
});

if (siteHeader) scrollHeader();
window.addEventListener("scroll", function(event) {
    if (siteHeader) scrollHeader();
});